/**
 * Created by Jie Gao on 17/02/2020.
 */

///<reference path="../../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomBounce.d.ts"/>
///<reference path="../../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomWiggle.d.ts"/>
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {GGGameModuleConfig} from "./GGGameModuleConfig";
import {GGWinFieldController} from "./winpresentation/GGWinFieldController";

export class GoldenGoblins extends SlotGame {
    constructor() {
        super(GGGameModuleConfig.instance);
    }

    protected startMainAmbience():void {}

    protected createWinFieldController(): GGWinFieldController {
        return new GGWinFieldController();
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "M3",
                    "L4",
                    "M4"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "M2",
                    "M1",
                    "M2"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "L5",
                    "L4",
                    "M5"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "L2",
                    "L3",
                    "L1"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "L3",
                    "M3",
                    "L5"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "L2",
                    "L2",
                    "L3"
                ]
            ],
            "evaluatedArea": [
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "M3",
                    "L4",
                    "M4"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "M2",
                    "M1",
                    "M2"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "L5",
                    "L4",
                    "M5"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "L2",
                    "L3",
                    "L1"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "L3",
                    "M3",
                    "L5"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "L2",
                    "L2",
                    "L3"
                ]
            ],
            "betWayWins": [],
            "totalBetLineWinnings": 0,
            "thisAvalancheWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "nearWinPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "roundType": 0,
            "bombGuarantee": false,
            "nextMode": "NORMAL",
            "freespinTriggeredThisSpin": false,
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "scatterPositionsEnteringFreespin": [
                -1,
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "nearWinBigWinReels": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "gameAreaSize": 3,
            "gameAreaSizeNextSpin": 3,
            "totalNumberOfWays": [
                729,
                729,
                729,
                729,
                729,
                729
            ],
            "reelsAfterCollapse": [
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "M3",
                    "L4",
                    "M4"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "M2",
                    "M1",
                    "M2"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "L5",
                    "L4",
                    "M5"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "L2",
                    "L3",
                    "L1"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "L3",
                    "M3",
                    "L5"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "L2",
                    "L2",
                    "L3"
                ]
            ],
            "allWinPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "numberOfScatters": 0,
            "numberOfWaysWon": 0,
            "avalancheCountThisSpinBefore": 0,
            "avalancheCountThisSpinAfter": 0,
            "newSymbols": [],
            "totalAvalancheRoundWinnings": 0,
            "numberOfScattersBefore": 0,
            "featureBuyTimesBetValue": [
                {
                    "name": "FREESPIN",
                    "type": "FREESPIN",
                    "price": 60
                },
                {
                    "name": "FREESPIN_LEVEL4",
                    "type": "FREESPIN",
                    "price": 150
                },
                {
                    "name": "FREESPIN_SUPER",
                    "type": "FREESPIN",
                    "price": 300
                },
                {
                    "name": "FREESPIN_LEVEL5",
                    "type": "FREESPIN",
                    "price": 666
                },
                {
                    "name": "FREESPIN_LEVEL3",
                    "type": "FREESPIN",
                    "price": 181
                },
                {
                    "name": "FREESPIN_LEVEL6",
                    "type": "FREESPIN",
                    "price": 32
                }
            ],
            "wasFeatureBuy": false,
            "topTrain": {
                "symbols": [
                    "M4",
                    "M1",
                    "M2",
                    "M5"
                ],
                "beforeSpellSymbols": [
                    "M4",
                    "M1",
                    "M2",
                    "M5"
                ],
                "evil4": false,
                "frozenPositions": [
                    false,
                    false,
                    false,
                    false
                ],
                "frozenThisTurn": [
                    false,
                    false,
                    false,
                    false
                ],
                "evil4Symbol": "",
                "evil4multiplier": 0,
                "goblinSpellActivated": [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                "goblinSpellActivatedLastRound": [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                "goblinSpellTransform": [
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ]
                ]
            },
            "autoDead": -1,
            "brokeBank": false,
            "xBombs": {
                "bombsPositions": [
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ]
                ],
                "bombedArea": [
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ]
                ],
                "displayMultiplier": 0,
                "multipliers": 0,
                "bomb": false
            },
            "doubleBombSpins": -1,
            "wasRandomBuy": false,
            "topTrainAnticipation": [
                false,
                false,
                false,
                false
            ],
            "multiplierBeforeFeast": -1
        };
    }
}